import React from 'react';

export const Done: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
  <svg viewBox="3 3 10 10" {...props}>
    <path
      d="M12.055 6.3l-4.334 4.338a.666.666 0 01-.943 0L4.612 8.471a.667.667 0 01.943-.943l1.7 1.7 3.862-3.862a.667.667 0 01.943.943zm0 0"
      fill="currentColor"
    />
  </svg>
);
